<template>
  <div id="game-wrapper">
    <div id="title-screen" :class="{'active':showTitleScreen}"  @click="startGame" @touchstart="startGame">
      <img id="title-img" src="../src/assets/img/titel-bild.jpg">
      <img src="../src/assets/img/titel.jpg">
    </div>
    <div id="game" :class="{'active':showGame}">
      <img src="../src/assets/img/passionsaltar.jpg">
    </div>
    <div id="draggables" :class="{'active': showGame}">
      <div
        v-for='item in draggableItems'
        :key='item.id'
        :id="item.name"
        :class="{ 'active': item.active, draggable: true, dragged: item.dragged, placed: item.placed}"
        @touchstart='startDrag($event, item)'
        @mousedown='startDrag($event, item)'
        @touchend='dragEnd($event, item)'
        @mouseup='dragEnd($event, item)'
      >
        <img :src="require('@/assets/img/'+ item.name + '.png')" alt="item.name">
      </div>
    </div>
    <div
      v-for="item in dropableItems"
      :key="item.id"
      :id="item.name"
      :class="{'dropable': true, 'dropped': item.dropped}"
      @drop='onDrop($event, 1)'
      @dragover.prevent
      @dragenter.prevent
    ></div>
    <div class="message active" v-if="message" v-on:click="closeMessage">
      <div :class="{'popup': true, 'wide': widerMessage}">
        <p v-html="messageContent"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Passionsaltar',
  data () {
    return {
      $dragElement: null,
      dragItem: null,
      showTitleScreen: true,
      showGame: false,
      message: false,
      messageContent: '',
      widerMessage: false,
      messages: [
        { id: 0, html: '<b>Observe attentivement l’image </b><br>et associe les objets aux scènes ou aux personnages du retable&nbsp;!' },
        { id: 1, html: '<b>Bien joué&nbsp;!</b> <br>Tu as trouvé tous les éléments.' }
      ],
      draggableItems: [
        { id: 0, name: 'Gugel', html: 'Ceci est une <b>gugel</b>. Il s’agit d’une sorte de capuchon avec un col sur les épaules. Le plus souvent, il était fait d’un simple tissu de laine, mais pour les riches, on en confectionnait aussi dans des tissus coûteux ou même avec une garniture en fourrure - comme ici sur le tableau.', required: 'Gugel-Drop', active: true },
        { id: 1, name: 'Hahn', html: '<b>Le coq</b> est en train de chanter - Jésus a prédit que son disciple Pierre le renierait trois fois au cours de la même nuit avant que le coq chante au lever du jour. C’est précisément ce qui se passe et Pierre regrette beaucoup de ne pas avoir été assez courageux pour défendre sa foi et Jésus.', required: 'Hahn-Drop', active: false },
        { id: 2, name: 'Haube', html: 'Au Moyen Âge, les femmes mariées devaient couvrir leurs cheveux d’une <b>coiffe</b>. Celles qui n’étaient pas mariées avaient le droit de montrer leurs cheveux. C’est de là que vient l’expression «&nbsp;coiffer le bonnet&nbsp;» lorsque quelqu’un se marie.', required: 'Haube-Drop', active: false },
        { id: 3, name: 'Skorpion', html: '<b>Le scorpion</b> est souvent utilisé comme symbole du mal. Ici, il est représenté sur le drapeau et permet d’identifier le groupe des ennemis de Jésus.', required: 'Skorpion-Drop', active: false },
        { id: 4, name: 'Trippen', html: 'Au Moyen Âge, il était à la mode, surtout chez les gens riches, de porter des chaussures à longues pointes. C’est de là que vient l’expression allemande «&nbsp;vivre sur un grand pied&nbsp;», c’est-à-dire mener une vie luxueuse. On appelle ces sur-chaussures en bois des <b>socques</b>. Elles protégeaient en outre les pieds contre le froid et la saleté.', required: 'Trippen-Drop', active: false }
      ],
      dropableItems: [
        { id: 5, name: 'Gugel-Drop', dropped: false },
        { id: 6, name: 'Hahn-Drop', dropped: false },
        { id: 7, name: 'Haube-Drop', dropped: false },
        { id: 8, name: 'Skorpion-Drop', dropped: false },
        { id: 9, name: 'Trippen-Drop', dropped: false }
      ],
      placedItems: [],
      touchmoveEventListener: (evt) => { this.drag(evt) },
      touchendEventListener: (evt) => { this.dragEnd(evt) }
    }
  },
  methods: {
    startGame () {
      this.showTitleScreen = false
      this.showGame = true
      setTimeout(this.showMessage, 10, this.messages[0].html)
    },
    startDrag (evt, item) {
      evt.preventDefault()
      evt.stopPropagation()
      if (!this.placedItems.includes(item.id)) {
        this.$dragElement = evt.target
        if (this.$dragElement.nodeName === 'IMG') this.$dragElement = this.$dragElement.parentNode
        const box = this.$dragElement.getBoundingClientRect()
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.mouseOffset = { x: c.clientX - box.left, y: c.clientY - box.top }
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
        this.$set(item, 'dragged', true)
        this.dragItem = item
        window.addEventListener(evt.type === 'mousedown' ? 'mousemove' : 'touchmove', this.touchmoveEventListener)
        window.addEventListener(evt.type === 'mousedown' ? 'mouseup' : 'touchend', this.touchendEventListener)
      }
    },
    drag (evt) {
      evt.preventDefault()
      evt.stopPropagation()
      if (this.$dragElement && this.$dragElement.mouseOffset) {
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
      }
    },
    dragEnd (evt) {
      if (this.dragItem) {
        const c = evt.type.match(/^touch/) ? evt.changedTouches[0] : evt
        const box = this.dragItem.required ? this.$el.querySelector('#' + this.dragItem.required).getBoundingClientRect() : null
        if (box) {
          const clickMargin = box.width / 4
          if (box.left < c.clientX && box.right - clickMargin > c.clientX && box.top < c.clientY && box.bottom > c.clientY) {
            this.onDrop()
            return
          }
        }
        this.resetDragElement()
        this.removeEventListeners()
        this.$dragElement = null
        this.dragItem = null
      }
    },
    onDrop () {
      if (this.dragItem) {
        this.showMessage(this.dragItem.html)
        this.draggableItems[this.placedItems.length].active = false
        this.placedItems.push(this.dragItem.id)
        for (var n = 0; n < this.dropableItems.length; n++) {
          if (this.dropableItems[n].name === this.dragItem.required) this.dropableItems[n].dropped = true
        }
        if (this.placedItems.length < this.draggableItems.length) this.draggableItems[this.placedItems.length].active = true
        this.$dragElement = null
        this.dragItem = null
      }
    },
    resetDragElement () {
      if (this.$dragElement) {
        this.$dragElement.style.zIndex = 'auto'
        this.$dragElement.style.left = null
        this.$dragElement.style.top = null
        this.$set(this.dragItem, 'dragged', false)
      }
    },
    removeEventListeners () {
      window.removeEventListener('mousemove', this.touchmoveEventListener)
      window.removeEventListener('touchmove', this.touchmoveEventListener)
      window.removeEventListener('mouseup', this.touchendEventListener)
      window.removeEventListener('touchend', this.touchendEventListener)
    },
    closeMessage () {
      this.message = false
      this.messageContent = ''
      if (this.placedItems.length === this.draggableItems.length) {
        this.placedItems.push('ende')
        this.showMessage(this.messages[1].html)
      }
    },
    showMessage (htmlText) {
      this.message = true
      this.widerMessage = htmlText.length > 150
      this.messageContent = htmlText
    }
  }
}
</script>
